export default "__VITE_ASSET__Fe4FzMSd__"